// extracted by mini-css-extract-plugin
export default {"dashboard-form-title":"f9e625"};